export default "__VITE_ASSET__BRaQ950u__"